import *as React from 'react';
import { Input, Button } from "antd";
import Form from "antd/lib/form";
import { FormComponentProps } from 'antd/es/form';
import notification from 'antd/lib/notification';
import MaskedInput from 'antd-mask-input'
import moment from 'moment';

interface SearchFormProps extends FormComponentProps {
  dispatchMethod: any;
  isSubmitEnabled: any;
}

function hasErrors(fieldsError: any, getFieldsValue: any) {

  const fName = fieldsError["pglobalFname"] ? fieldsError["pglobalFname"].value : "";
  const fNameVal = getFieldsValue["pglobalFname"] ? getFieldsValue["pglobalFname"].value : "";
  const dob = fieldsError["datepicker"] ? fieldsError["datepicker"].value : "";
  const dobVal = getFieldsValue["datepicker"] ? getFieldsValue["datepicker"].value : "";
  const phoneNum = fieldsError["pglobalphone"] ? fieldsError["pglobalphone"].value : "";
  const Phone = getFieldsValue["pglobalphone"] ? getFieldsValue["pglobalphone"].value : "";

  if (Phone != "" && phoneNum == "") {
    return false;
  }
  else if (fNameVal != "" && fName == "") {
    return false;
  }
  else if (dobVal != "" && dob == "") {
    return false;
  }
  else {
    return true;
  }

}
class AdvancedSearchForm extends React.Component<SearchFormProps, any>{

  componentDidMount() {
    this.props.form.validateFields();
  }

  handleGlobalSearch = (e: any) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (values && (values.pglobalId === "")) {
        this.props.form.setFields({
          pglobalId: {
            value: undefined
          }
        });
      }
      if (values && (values.pglobalphone === "")) {
        this.props.form.setFields({
          pglobalphone: {
            value: undefined,
          },
        });
      }
      if (values && (values.pglobalFname === "")) {
        this.props.form.setFields({
          pglobalFname: {
            value: undefined,
          },
        });
      }
      if (values && (values.datepicker === "")) {
        this.props.form.setFields({
          datepicker: {
            value: undefined,
          },
        });
      }
      const patientId = values["pglobalId"] ? values["pglobalId"] : "";
      const name = values["pglobalFname"] ? values["pglobalFname"] : "";
      let dob = values["datepicker"] ? values["datepicker"] : "";
      const phone = values["pglobalphone"] ? values["pglobalphone"] : "";
      let presentdate = new Date();
      let datevalue = new Date(dob);
      if ((name === undefined || name === "" || name === ' ') &&
        (dob === undefined || dob === "" || dob === ' ') &&
        (phone === undefined || phone === "" || phone === ' ') &&
        (patientId === undefined || patientId === "" || patientId === ' ')) {
        notification.config({
          placement: "topRight",
          top: 300,
          duration: 3
        });
        notification['error']({
          message: 'Enter the search criteria',
          description:'',
        });
      } else if(patientId && patientId?.length < 3) {
        notification.config({
          placement: "topRight",
          top: 300,
          duration: 3
        });
        notification['error']({
          message: 'Enter Minimum 3 and Maximum 15 characters for Patient ID',
          description:'',
        });
      } else if(patientId && patientId?.length > 15) {
        notification.config({
          placement: "topRight",
          top: 300,
          duration: 3
        });
        notification['error']({
          message: 'Enter Minimum 3 and Maximum 15 characters for Patient ID',
          description:'',
        });
      } else if ((name!= "" && name?.length < 3)) {
        notification.config({
          placement: "topRight",
          top: 300,
          duration: 3
        });
        notification['error']({
          message: 'Enter Minimum 3 and Maximum 30 characters for Name',
          description:'',
        });
      } else if ((name?.length > 30)) {
        notification.config({
          placement: "topRight",
          top: 300,
          duration: 3
        });
        notification['error']({
          message: 'Enter Minimum 3 and Maximum 30 characters for Name',
          description:'',
        });
      }  

      //ADPAC-3376 
      else if ((dob!= "" && dob?.length < 8 ) || (datevalue > presentdate || dob === "00-00-0000") || !(moment(dob).isValid()) &&
      (name === undefined || name === "" || name === ' ') && (phone === undefined || phone === "" || phone === ' ') &&
      (patientId === undefined || patientId === "" || patientId === ' ')) {
        notification.config({
          placement: "topRight",
          top: 300,
          duration: 3
        });
        notification['error']({
          message: 'Enter Valid DOB',
          description:'',
        });
      } else if ((phone!= "" && phone?.length < 10)) {
        notification.config({
          placement: "topRight",
          top: 300,
          duration: 3
        });
        notification['error']({
          message: 'Enter Valid Phone Number',
          description:'',
        });
      }else {
        this.props.dispatchMethod(this.props.form.getFieldsValue());
      }
    });
  };

  handleReset = () => {
    this.props.form.resetFields();
  };

  render() {
    const { getFieldDecorator, getFieldError, isFieldTouched } = this.props.form;
    const patientIderror = isFieldTouched('pglobalId') && getFieldError('pglobalId');
    const PatientFstNameError = isFieldTouched('pglobalFname') && getFieldError('pglobalFname');
    const PatientPhoneError = isFieldTouched('pglobalphone') && getFieldError('pglobalphone');
    const patientDobError = isFieldTouched('datepicker') && getFieldError('datepicker');
    return (
      <Form
        className="ant-advanced-search-form"
        layout="vertical"
        onSubmit={(e) => this.handleGlobalSearch(e)}
      >
        <div className="global-search-item-container">
          <div className="global-search-item">
            <text>Name:</text>
            <Form.Item className={"formantd"} style={{ fontSize: "12px" }} validateStatus={PatientFstNameError ? 'error' : ''} help={PatientFstNameError || ''}>
              {getFieldDecorator("pglobalFname", {
                rules: [{ required: false, message: "Enter Min 3 and Max 30 characters", whitespace: true, type: "string", min: 3, max: 30 }]
              })(
                <Input
                  autoComplete="new-password"
                  placeholder="Name"
                  size="small"
                  onChange={event => {
                    this.props.form.setFieldsValue({
                      pglobalFname: `${event.target.value}`
                    });
                  }}
                />
              )}
            </Form.Item>
          </div>
          <div className="global-search-item">
            <text>DOB:</text>
            <Form.Item className={"formantd"} validateStatus={patientDobError ? 'error' : ''} help={patientDobError || ''}>
              {getFieldDecorator("datepicker", {
                rules: [{ required: false, message: "Please enter DOB in MMDDYYYY format", whitespace: true, type: "string", min: 8, max: 10 }]
              })(
                <MaskedInput mask="11-11-1111" name="datepicker"size="small" placeholder="MM-DD-YYYY" onChange={(event:any) => {
                  this.setState({[event.target.name]: event.target.value})
                }}/>

              )}
            </Form.Item>
          </div>
          <div className="global-search-item">
            <text>Patient ID:</text>
            <Form.Item className={"formantd"} style={{ fontSize: "12px" }} validateStatus={patientIderror ? 'error' : ''} help={patientIderror || ''}>
              {getFieldDecorator("pglobalId", {
                rules: [{ required: false, message: "Invalid PatientID", whitespace: true, type: "string", min: 3, max: 15 }]
              })(
                <Input
                  autoComplete="new-password"
                  placeholder="Patient ID"
                  size="small"
                  onChange={event => {
                    this.props.form.setFieldsValue({
                      pglobalId: `${event.target.value}`
                    });
                  }}
                />
              )}
            </Form.Item>
          </div>
          <div className="global-search-item">
            <text>Phone:</text>
            <Form.Item className={"formantd"} style={{ fontSize: "10px" }} validateStatus={PatientPhoneError ? 'error' : ''} help={PatientPhoneError || ''}>
              {getFieldDecorator("pglobalphone", {
                rules: [{ required: false, message: "Please enter 10 Digit Phone number", whitespace: false, type: "string", min: 10, max: 14 }]
              })(
                <MaskedInput mask="111-111-1111" name="pglobalphone" size="small" placeholder="Phone Number" onChange={(event:any) => {
                  this.setState({[event.target.name]: event.target.value})
                }}/>
              )}
            </Form.Item>
          </div>
          <div className="global-search-item global-search-item--btn-group">
            <Button type="primary" size="small" htmlType="submit" style={{ marginTop: "20px", zIndex: 100 }}>Search</Button>
            <Button type="primary" size='small' onClick={this.handleReset} style={{ marginTop: "20px" }}>Clear</Button>
          </div>
        </div>

      </Form>
    )
  }
}
export const PatientAdvancedSearchForm = Form.create<SearchFormProps>({

})(AdvancedSearchForm)

